import { render, staticRenderFns } from "./MfaSettings.vue?vue&type=template&id=b1623d54&scoped=true"
import script from "./MfaSettings.vue?vue&type=script&lang=ts"
export * from "./MfaSettings.vue?vue&type=script&lang=ts"
import style0 from "./MfaSettings.vue?vue&type=style&index=0&id=b1623d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1623d54",
  null
  
)

export default component.exports